import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

export const fetchSections = () => api.get("/handbook/sections").then(r => r.data);
export const fetchSection = (id) => api.get(`/handbook/sections/${id}`).then(r => r.data);
export const searchHandbook = (q) => api.get("/handbook/search", { params: { q } }).then(r => r.data);
export const fetchEmergencyContacts = () => api.get("/handbook/emergency-contacts").then(r => r.data);
export const fetchFare = (miles) => api.get(`/fare/${miles}`).then(r => r.data);
export const fetchTowns = () => api.get("/mileage/towns").then(r => r.data);
export const fetchDistance = (from_town, to_town) =>
    api.get("/mileage/distance", { params: { from_town, to_town } }).then(r => r.data);
export const sendChat = (message, session_id) =>
    api.post("/chat", { message, session_id }).then(r => r.data);
export const fetchChatHistory = (session_id) =>
    api.get(`/chat/history/${session_id}`).then(r => r.data);
export const recordAck = (payload) =>
    api.post("/training/ack", payload).then(r => r.data).catch(() => null);
export const recordCertificate = (payload) =>
    api.post("/training/certificate", payload).then(r => r.data).catch(() => null);
export const fetchAdminStats = (key) =>
    api.get("/admin/stats", { params: { key } }).then(r => r.data);
